// Add swatch-parent class as a parent class when adding swatch to any section

$(document).ready(function() {
  var data_var_id;
  $(document).on('click', '.freq-checkbox', function(event) {
    totalPriceDisplay();
  });

  function totalPriceDisplay() {
    var totalPrice = parseFloat(0);
    var totalComparePrice = parseFloat(0);
    var total_saving = parseFloat(0);
     $(".freq-checkbox").each(function() {
       if($(this).is(":checked")){
         var product_id = $(this).data('product-id');
          var priceText = $(".check-price-"+product_id).text();
          var priceNumber = parseFloat(priceText.replace(/[^\d\- ]/g, "")); 
          totalPrice = (totalPrice + priceNumber);
          var comparetext = $(".check-compareprice-"+product_id).text();
          if(comparetext != "" ){
            var compareNumber = parseFloat(comparetext.replace(/[^\d\- ]/g, ""));
            var main_com_price = (compareNumber - priceNumber);
            totalComparePrice = (totalComparePrice + main_com_price);
          }
       } 
      });
      if(totalComparePrice > 0){
         total_saving = totalComparePrice;
      }
      var total_save = Shopify.formatMoney(total_saving);
      $(".total-price-main").html(Shopify.formatMoney(totalPrice));
      $(".total-price-save").html("You save:" + total_save);
      if(total_saving == 0){
        $(".total-price-save").hide();
      } else{
        $(".total-price-save").show();
      }
  }
  $(document).on('change', '.variant-option input[type="radio"]', function(event) {
    var main_product_id = $(this).attr("product_id");
    var main_name = $(this).attr("name");
     $('.radio-selected-custom-' + main_name + '-' + main_product_id).removeClass("radio-selected");
      $(this).addClass("radio-selected");
    var title = '';
    var length = $(this).parents('.swatch-parent').find('.variant-row').find('.variant-option').length;
    if(length > 1){
      $(this).parents('.variant-row').find('.variant-option').each(function( index,value ) {
        title += $(value).find('.variant_change').find('input[type="radio"]:checked').val()+" / ";
      });
      title = title.slice(0,-3)
    } else{
      $(this).parents('.variant-row').find('.variant-option').each(function( index,value ) {
        title += $(value).find('.variant_change').find('input[type="radio"]:checked').val();
      });
    }
    var variant_id = $(this).parents('.swatch-parent').find('.variant-row').find("select option[data_title='"+title+"']").val();
    $(this).parents('.variant-row').find('input[type="hidden"]').val(variant_id);
    data_var_id = $(this).parents('.variant-row').find('input[type="hidden"]').val();

    var variant_title = '';
    $(this).parents('.variant-row').find('.variant-option').each(function( index ) {
      variant_title +=  " / "+$(this).find('input[type="radio"]:checked').val();
    });
    variant_title = variant_title.slice(3);
    var var__price = $(this).parents('.variant-row').find('.product-select option[data_title="'+variant_title+'"]').attr('data-varprice');
    var var_compare_price = $(this).parents('.variant-row').find('.product-select option[data_title="'+variant_title+'"]').attr('data-varcompprice');
    var var_image = $(this).parents('.variant-row').find('.product-select option[data_title="'+variant_title+'"]').attr('data-varimage');
    $(this).parents(".product-block").find(".frq-price-row").find(".price").html(Shopify.formatMoney(var__price));
    if(var_compare_price != ''){
      $(this).parents(".product-block").find(".frq-price-row").find(".compare-price").html(Shopify.formatMoney(var_compare_price));
    }else{
      $(this).parents(".product-block").find(".frq-price-row").find(".compare-price").html("");
    }
    if(var_image != ""){
      $(this).parents(".product-block").find("img.variant-image-update").attr("src", var_image);
    }
    
    if(var_compare_price > var__price || var_compare_price != ""){
      var variant_discount = ((var_compare_price - var__price) * 100) / var_compare_price;
      $(this).parents(".product-block").find(".frq-price-row").find(".discount-tag").html(Math.round(variant_discount.toFixed(2)) + "%");
      $(this).parents(".product-block").find(".frq-price-row").find(".discount-tag").show();     
    } else{
      $(this).parents(".product-block").find(".frq-price-row").find(".discount-tag").hide();
    }
    totalPriceDisplay();
    
  });
  
  $(document).on('click', '.add-to-cart-btn', function(event) {
    event.preventDefault();
    var data_array = [];
    $(".swatch-parent input[type=checkbox]:checked").each(function(){
      data_array.push($(this).parent().find('input[type="hidden"]').val());
    });
    if ($('.swatch-parent input[type=checkbox]').is(':checked')) {
      var data = {
        "quantity": 1,
        "id": data_array
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(data) {
          window.location = "/cart";
        },
        error: function (data) {
          if (data.status == 422) {
          alert("Selected product from bundle is already soldout!");
        }
        }
      });
    }
    $(".variant_change").on("click", function(){ 
      $(this).parent().find('.variant_change').find('input[type="radio"]').removeAttr('checked');
      $(this).find('input[type="radio"]').attr("checked","checked");
    });
  
  });
  $(".freq-bought .freq-checkbox").trigger("click"); //all checkbox click
});